import { serviceSettingsConstants } from "../_constants";
import { serviceSettingsServices } from "../_services";
import { alertActions } from ".";

export const serviceSettingsActions = {
  getServiceSettingsList,
  getServiceSettingsDetails,
  updateServiceSettingsTypes,
  updateServiceSettingsStatus, 
};
function getServiceSettingsDetails(serviceId) {
  return (dispatch) => {
    dispatch(request());
    serviceSettingsServices.getServiceSettingsDetails(serviceId).then(
      (service) => dispatch(success(service)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: serviceSettingsConstants.GET_SERVICE_SETTINGS_REQUEST };
  }
  function success(service) {
    return {
      type: serviceSettingsConstants.GET_SERVICE_SETTINGS_SUCCESS,
      service,
    };
  }
  function failure(error) {
    return {
      type: serviceSettingsConstants.GET_SERVICE_SETTINGS_FAILURE,
      error,
    };
  }
}

function getServiceSettingsList() {
  return (dispatch) => {
    dispatch(request());
    serviceSettingsServices.getServiceSettingsList().then(
      (serviceSettings) => dispatch(success(serviceSettings)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: serviceSettingsConstants.GET_SERVICE_SETTINGS_LIST_REQUEST };
  }
  function success(serviceSettings) {
    return {
      type: serviceSettingsConstants.GET_SERVICE_SETTINGS_LIST_SUCCESS,
      serviceSettings,
    };
  }
  function failure(error) {
    return {
      type: serviceSettingsConstants.GET_SERVICE_SETTINGS_LIST_FAILURE,
      error,
    };
  }
}



function updateServiceSettingsTypes(typeId, serviceId) {
  return (dispatch) => {
    dispatch(request());
    serviceSettingsServices.updateServiceSettingsTypes(typeId, serviceId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: serviceSettingsConstants.UPDATE_SERVICE_TYPES_REQUEST };
  }
  function success(data) {
    return {
      type: serviceSettingsConstants.UPDATE_SERVICE_TYPES_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: serviceSettingsConstants.UPDATE_SERVICE_TYPES_FAILURE,
      error,
    };
  }
}

function updateServiceSettingsStatus(statusId, serviceId) {
  return (dispatch) => {
    dispatch(request());
    serviceSettingsServices.updateServiceSettingsStatus(statusId, serviceId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: serviceSettingsConstants.UPDATE_SERVICE_STATUS_REQUEST };
  }
  function success(data) {
    return {
      type: serviceSettingsConstants.UPDATE_SERVICE_STATUS_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: serviceSettingsConstants.UPDATE_SERVICE_STATUS_FAILURE,
      error,
    };
  }
}
